module.exports = __webpack_public_path__ + "static/media/landing-page-photo-v3-mobile.165b1b2f.jpg";